$(document).ready(function () {
    //l1
    $('#btnMenu').click(function(e) {
        $(this).parent().find('.ctn-main-menu').addClass('opn-l1');
        e.stopPropagation();
    });
    $('#btnCloseMenu').click(function() {
		$('.ctn-main-menu').removeClass('opn-l1');
	});

    //l2
    $('[data-submenu-l1=\'true\'] > span').click(function(e) {
        $(this).parent().find('.ctn-mn-l2').addClass('opn-l2');
        e.stopPropagation();
    });
    $('.l2-back').click(function() {	
		$(this).parent().parent().parent().removeClass('opn-l2');
	});

    //l3
    $('[data-submenu-l2=\'true\'] > span').click(function(e) {
        $(this).parent().find('.ctn-mn-l3').addClass('opn-l3');
        e.stopPropagation();
    });
    $('.l3-back').click(function() {	
		$(this).parent().parent().removeClass('opn-l3');
	});

    //l4
    $('[data-submenu-l3=\'true\'] > span').click(function(e) {
        $(this).parent().find('.ctn-mn-l4').addClass('opn-l4');
        e.stopPropagation();
    });
    $('.l4-back').click(function() {	
		$(this).parent().parent().removeClass('opn-l4');
	});

    //l5
    $('[data-submenu-l4=\'true\'] > span').click(function(e) {
        $(this).parent().find('.ctn-mn-l5').addClass('opn-l5');
        e.stopPropagation();
    });
    $('.l5-back').click(function() {	
		$(this).parent().parent().removeClass('opn-l5');
	});
    
});